


































import { Vue, Component } from "vue-property-decorator";
import TestForm from "@/components/tests/TestForm.vue";
import { Test as ITest } from "@/api/models/test";
import { TestQuestionsList as ITestQuestionsList } from "@/api/models/test-questions-list";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, TestForm }
})
export default class TestEdit extends Vue {
  testInfo!: ITest;
  testQuestions: Array<ITestQuestion> = [];
  isLoading: boolean = false;
  isUpdatingQuestions: boolean = false;
  offset: number = 0;
  limit: number = 100;
  count: number = 0;

  data() {
    return {
      testInfo: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "testList" },
        label: this.$tc(this.$translate.Tests)
      },
      {
        label: this.testInfo.title
      }
    ];
  }

  async updateOrder() {
    this.limit = 100;
    this.offset = 0;
    this.testQuestions = [];
    this.isUpdatingQuestions = true;
    await this.getQuestions();
    this.isUpdatingQuestions = false;
  }

  backRoute() {
    this.$router.go(-1);
  }

  async getQuestions() {
    await api.TestApi.listQuestions(this.testInfo.id, this.offset, this.limit)
      .then(async (questions: { data: ITestQuestionsList }) => {
        this.count = questions.data.count;
        this.testQuestions = [
          ...this.testQuestions,
          ...questions.data.questions
        ];
        if (this.testQuestions.length + 1 < questions.data.count) {
          this.offset += this.limit;
          await this.getQuestions();
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  async init() {
    this.limit = 100;
    this.offset = 0;
    this.testQuestions = [];
    this.isLoading = true;
    await api.TestApi.get(this.$route.params.testId)
      .then(async (res: { data: ITest }) => {
        this.testInfo = res.data;
        document.title += ` ${this.testInfo.title}`;
        if (this.testInfo) {
          await this.getQuestions();
          this.isLoading = false;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.init();
  }
}
